import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wallet-list',
  templateUrl: './wallet-list.component.html',
  styleUrls: ['./wallet-list.component.scss']
})
export class WalletListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
